export default __webpack_public_path__ + "static/media/telegram.f75c860d.svg";